import { jsx as _jsx } from "react/jsx-runtime";
import { SvgIcon } from '@mui/material';
export const RightArrow = props => (_jsx(SvgIcon, { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", ...props, children: _jsx("path", { d: "M9.37505 18.0002L8.30005 16.9252L13.25 11.9752L8.30005 7.0252L9.37505 5.9502L15.4 11.9752L9.37505 18.0002Z", fill: "#49454F" }) }));
